import axios from 'axios'
import store from '@/store/index.js'

export async function getCollections(scope) {

  return await axios.get(process.env.VUE_APP_API_HOST + '/collections', {params:{scope}})
}

export async function startFileGeneration(collectionId) {
  return await axios.post(process.env.VUE_APP_API_HOST + '/collection_file/' + collectionId)
}

export async function getDownloadUrl(collectionId) {
  return await axios.get(process.env.VUE_APP_API_HOST + '/collection_file/' + collectionId)
}

export async function getCollection(collectionId) {
  return await axios.get(process.env.VUE_APP_API_HOST + '/collection/' + collectionId)
}

export async function createCollection(name) {
  return await axios.post(process.env.VUE_APP_API_HOST + '/collections', {
    name: name
  })
}

export async function deleteCollection(collectionId){
  return await axios.put(process.env.VUE_APP_API_HOST + '/collection/' + collectionId, {

    is_deleted: true

  }
  )
}



export async function createCollectionItem(collectionId, cusip) {
  // console.log(collectionId, cusip)
  return await axios.post(process.env.VUE_APP_API_HOST + '/collection_items', {
    collection_id: collectionId,
    cusip: cusip.cusip,
    security_type: cusip.security_type
  })
}
export async function updateCollection(collection_id, name, is_shared=false){
    return await axios.put(process.env.VUE_APP_API_HOST + '/collection/' + collection_id,
    {
      name: name,
      is_shared_with_account: is_shared
    });
  }

export async function renameCollection(collection_id, name){
  return await axios.put(process.env.VUE_APP_API_HOST + '/collection/' + collection_id,
  {
    name: name
  });
}

export async function getCollectionItems(collection) {

  return await axios.get(process.env.VUE_APP_API_HOST + '/collection_items', {
    params: {
      collection_id: collection.id
    }
  })
}

export function update(item){

    updateCollection(item.id, item.name, item.is_shared_with_account).then(
      res => {
                store.dispatch('updateState', ['collection', res.data]);

                //updating myCollections in store so that collection name will re-render

                //you're only allowed to update your collections
               let   myCollections = store.state.myCollections.map(
                    x => x.id===item.id? res.data : x
                  );




                   store.dispatch('updateState',['myCollections', myCollections])


                })
            }
